import moment from "moment";
import { BASE_URL } from "./BaseUrl";
import { setGymData } from "../redux/reducers/gymDataSlice";
import { setTrainersData } from "../redux/reducers/trainerDataSlice";
import { setAssigneeData } from "../redux/reducers/assigneeDataSlice";
import {
  ticketSystem,
  ticketSystemStats,
  ticketSystemTat,
} from "./ApiEndpoints";

export const fetchGymData =
  (authToken, pageNo, pageLimit, searchStr, status, query) =>
  async (dispatch) => {
    try {
      const response = await fetch(
        `${BASE_URL}/gym?is_device_id=1&status=${
          status === "all" ? "" : "active"
        }&limit=${pageLimit || 100}&page=${pageNo || 1}&search=${
          searchStr || ""
        }${query || ""}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      const data = await response.json();
      const gymNamesData = data.data.map((item) => ({
        value: item.user_id,
        label: item.gym_name,
        pagination: item.pagination,
        info: item,
      }));

      dispatch(setGymData(gymNamesData));
    } catch (error) {
      console.error("fetchGymData Error: ", error);
    }
  };

export const fetchTrainersData = (authToken, gymId) => async (dispatch) => {
  try {
    const url = gymId
      ? `trainer?page=1&limit=100&status=active&gym_id=${gymId}`
      : `trainer?page=1&limit=100&status=active`;
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });
    const data = await response.json();

    const trainersData = data?.data?.map((item) => {
      const shiftTimings = item?.shift_details?.map((shift) => {
        const startTime = shift?.start_time
          ? moment(shift.start_time, "HH:mm").tz("Asia/Kolkata").format("h:mmA")
          : "";
        const endTime = shift?.end_time
          ? moment(shift.end_time, "HH:mm").tz("Asia/Kolkata").format("h:mmA")
          : "";
        return `${startTime}-${endTime}`;
      });

      const shiftTiming = shiftTimings
        ? shiftTimings?.join(", ")
        : "No Shift Found!";

      return {
        value: item?.user_id,
        label: `${item.name} (${shiftTiming})`,
      };
    });

    // const trainersData = data?.data?.map((item) => ({
    //   value: item.user_id,
    //   label: item.name,
    // }));

    dispatch(setTrainersData(trainersData));
  } catch (error) {
    console.error("fetchTrainersData Error: ", error);
  }
};

export const fetchAllTrainer = async (filters, TOKEN) => {
  try {
    let url = `trainer`;
    const filteredParams = Object.entries(filters)
      .filter(([key, value]) => value !== "")
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join("&");
    if (filteredParams) {
      url += `?${filteredParams}`;
    }

    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllTrainer=> ", error);
    throw error;
  }
};

export const fetchAllAssigneeData = (TOKEN, gymQp) => async (dispatch) => {
  try {
    const response = await fetch(
      `${BASE_URL}/user/assignee?page=1&limit=1000${gymQp ? gymQp : ""}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
        },
      }
    );
    const data = await response.json();
    const assigneeData = data?.data?.map((item) => ({
      value: item.uid,
      label: item.name,
    }));
    dispatch(setAssigneeData(assigneeData));
  } catch (error) {
    console.error("fetchAllAssigneeData Error: ", error);
  }
};

export const fetchAllGyms = async (page, gymid, TOKEN) => {
  try {
    const response = await fetch(
      `${BASE_URL}/gym?page=${page}&limit=10&${gymid}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
        },
      }
    );
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllGymData=> ", error);
    throw error;
  }
};

export const fetchPTTrainers = async (gymId, authToken) => {
  try {
    const url = `trainer?page=1&limit=500&status=active&is_pt=1&gym_id=${gymId}`;

    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchPTTrainers Error: ", error);
  }
};

export const fetchAllSettlementData = async (queryParameters, TEMP_TOKEN) => {
  try {
    const response = await fetch(
      `${BASE_URL}/settelement/v2/list/all?${queryParameters}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${TEMP_TOKEN}`,
        },
      }
    );
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllSettlementData=> ", error);
    throw error;
  }
};

export const fetchAllCTOHeadData = async (token) => {
  try {
    const response = await fetch(`${BASE_URL}/settelement/v2/cto-heads`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllCTOHead=> ", error);
    throw error;
  }
};

export const fetchAllCTOData = async (queryParameters, TEMP_TOKEN) => {
  try {
    const response = await fetch(
      `${BASE_URL}/settelement/v2/cto?${queryParameters}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${TEMP_TOKEN}`,
        },
      }
    );
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllCTOData=> ", error);
    throw error;
  }
};

export const fetchCreateNewSettlement = async (queryParameters, TEMP_TOKEN) => {
  try {
    const response = await fetch(
      `${BASE_URL}/settelement/v2/settlment/create?type=view${queryParameters}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${TEMP_TOKEN}`,
        },
      }
    );
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchCreateNewSettlement=> ", error);
    throw error;
  }
};

export const fetchAllProfitShareData = async (queryParameters, TEMP_TOKEN) => {
  try {
    const response = await fetch(
      `${BASE_URL}/settelement/v2/share/details?${queryParameters}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${TEMP_TOKEN}`,
        },
      }
    );
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllProfitShareData=> ", error);
    throw error;
  }
};

export const createNewSettlementInitiate = async (
  queryParameters,
  TEMP_TOKEN
) => {
  try {
    const response = await fetch(
      `${BASE_URL}/settelement/v2/settlment/create?type=create${queryParameters}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${TEMP_TOKEN}`,
        },
      }
    );
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("createNewSettlementInitiate=> ", error);
    throw error;
  }
};

export const createNewCTOXXX = async (userData, authToken) => {
  try {
    const response = await fetch(`${BASE_URL}/settelement/v2/cto`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
      body: userData,
    });

    if (!response.ok) {
      throw new Error(
        "createNewCTO Request failed with status " + response.status
      );
    }

    const responseData = await response.json();
    return responseData;
  } catch (error) {
    console.error("createNewCTO =>", error);
    throw error;
  }
};

export const uploadCreatCtoFileXXX = async (fileData, authToken) => {
  try {
    const response = await fetch(`${BASE_URL}/notification/upload`, {
      method: "POST",
      headers: {
        // "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${authToken}`,
      },
      body: fileData,
    });

    if (!response.ok) {
      throw new Error(
        "uploadCreatCtoFile Request failed with status " + response.status
      );
    }

    const responseData = await response.json();
    return responseData;
  } catch (error) {
    console.error("uploadCreatCtoFile =>", error);
    throw error;
  }
};

export const fetchAllSettlementCards = async (queryParameters, TEMP_TOKEN) => {
  try {
    const response = await fetch(
      `${BASE_URL}/settelement/v2/settlment/stats?${queryParameters}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${TEMP_TOKEN}`,
        },
      }
    );
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllSettlementCards=> ", error);
    throw error;
  }
};

export const fetchAllSettlementCharts = async (queryParameters, TEMP_TOKEN) => {
  try {
    const response = await fetch(
      `${BASE_URL}/settelement/v2/settlment/chart?${queryParameters}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${TEMP_TOKEN}`,
        },
      }
    );
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllSettlementCharts=> ", error);
    throw error;
  }
};

export const fetchAllRenewalStats = async (queryParameters, TOKEN) => {
  try {
    const response = await fetch(
      `${BASE_URL}/renewal/stats/dashboard?is_stats=1${queryParameters}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
        },
      }
    );
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllRenewalStats=> ", error);
    throw error;
  }
};

export const fetchAllRenewalStatsAll = async (queryParameters, TOKEN) => {
  try {
    const response = await fetch(
      `${BASE_URL}/renewal/stats/dashboard?is_stats=1${queryParameters}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
        },
      }
    );
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllRenewalStatsAll=> ", error);
    throw error;
  }
};

export const fetchAllRenewalTable = async (
  pageNo,
  queryParameters,
  searchString,
  TOKEN
) => {
  const endPoint = searchString
    ? `renewal/stats/dashboard?is_stats=0&page=${pageNo}&limit=10${searchString}${queryParameters}`
    : `renewal/stats/dashboard?is_stats=0&page=${pageNo}&limit=10${queryParameters}`;
  try {
    const response = await fetch(`${BASE_URL}/${endPoint}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllRenewalTable=> ", error);
    throw error;
  }
};

export const fetchAllRenewalTableAll = async (
  queryParameters,
  searchString,
  TOKEN
) => {
  const endPoint = searchString
    ? `renewal/stats/dashboard?is_stats=0${queryParameters}${searchString}`
    : `renewal/stats/dashboard?is_stats=0${queryParameters}`;
  try {
    const response = await fetch(`${BASE_URL}/${endPoint}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllRenewalTableAll=> ", error);
    throw error;
  }
};

export const fetchAllIncentives = async (
  queryParameters,
  searchString,
  TOKEN
) => {
  const endPoint = searchString
    ? `renewal/incentive?${searchString}${queryParameters}`
    : `renewal/incentive?${queryParameters}`;
  try {
    const response = await fetch(`${BASE_URL}/${endPoint}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllIncentives=> ", error);
    throw error;
  }
};

export const fetchAllPastDiscussions = async (queryParameters, TEMP_TOKEN) => {
  try {
    const response = await fetch(
      `${BASE_URL}/renewal/discussion/logs?${queryParameters}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${TEMP_TOKEN}`,
        },
      }
    );
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllPastDiscussions=> ", error);
    throw error;
  }
};

export const fetchAllDiscussionLogs = async (discussionId, TOKEN) => {
  try {
    const response = await fetch(
      `${BASE_URL}/renewal/discussion/logs?discussion_id=${discussionId}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
        },
      }
    );
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllDiscussionLogs=> ", error);
    throw error;
  }
};

export const fetchAllRecentRenewal = async (queryParameters, TOKEN) => {
  try {
    const response = await fetch(
      `${BASE_URL}/renewal/recent_renewals?${queryParameters}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
        },
      }
    );
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllRecentRenewal=> ", error);
    throw error;
  }
};

export const fetchAllAddonsByGym = async (gymId, isPT, TOKEN) => {
  try {
    // Only append is_pt when caller passed a real value. Otherwise the URL
    // becomes "is_pt=undefined" which the backend treats as a literal filter
    // string and returns zero rows.
    const isPTParam =
      isPT === 1 || isPT === "1" || isPT === 0 || isPT === "0"
        ? `&is_pt=${isPT}`
        : "";
    const response = await fetch(
      `${BASE_URL}/addon?status=active&keyword=${gymId}${isPTParam}&is_web=1`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
        },
      }
    );
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllAddonsByGym=> ", error);
    throw error;
  }
};

export const fetchAllAddonSessions = async (addonId, TOKEN) => {
  try {
    const response = await fetch(`${BASE_URL}/session/addon?addon=${addonId}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllAddonSessions=> ", error);
    throw error;
  }
};

export const fetchAllAddonSlots = async (addonId, slotDate, TOKEN) => {
  try {
    const response = await fetch(
      `${BASE_URL}/slot/addon?addons_id=${addonId}&date=${slotDate}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
        },
      }
    );
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllAddonSlots=> ", error);
    throw error;
  }
};

export const fetchAllOffersByTypeId = async (typeId, sellingPrice, TOKEN) => {
  try {
    const response = await fetch(
      `${BASE_URL}/offer/?page=1&limit=100&is_web=1&status=active&type_id=${typeId}&selling_price=${sellingPrice}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
        },
      }
    );
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllOffersByTypeId=> ", error);
    throw error;
  }
};

export const checkOfferValidationByUser = async (userId, offerId, TOKEN) => {
  try {
    const response = await fetch(
      `${BASE_URL}/offervalidation?user_id=${userId}&offer_id=${offerId}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
        },
      }
    );
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("checkOfferValidationByUser=> ", error);
    throw error;
  }
};

export const checkOfferValidationByCode = async (typeId, code, TOKEN) => {
  try {
    const response = await fetch(
      `${BASE_URL}/offer/code?type_id=${typeId}&code=${code}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
        },
      }
    );
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("checkOfferValidationByCode=> ", error);
    throw error;
  }
};

export const fetchAllOnlinePaymentLinks = async (filters, TOKEN) => {
  let url = `subscription/draftorder`;

  const filteredParams = Object.entries(filters || {})
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllOnlinePaymentLinks=> ", error);
    throw error;
  }
};

export const fetchAllCashPaymentLinks = async (filters, TOKEN) => {
  let url = `subscription/draftorder/cash`;

  const filteredParams = Object.entries(filters || {})
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllCashPaymentLinks=> ", error);
    throw error;
  }
};

export const fetchUserDetailsByMobile = async (userMobile, TOKEN, qps) => {
  let url = `user?${qps ? qps : ""}`;

  if (userMobile) {
    url += `&mobile=${userMobile}`;
  }
  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchUserDetailsByMobile=> ", error);
    throw error;
  }
};

export const fetchAllReceptionists = async (TOKEN, qps) => {
  let url = `user/receptionist?${qps ? qps : ""}`;

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllReceptionists=> ", error);
    throw error;
  }
};

export const fetchAllTrainersByExperienceLevel = async (
  queryParameters,
  TOKEN
) => {
  try {
    const response = await fetch(
      `${BASE_URL}/trainer?page=1&limit=1000${queryParameters}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
        },
      }
    );
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllTrainersByExperienceLevel=> ", error);
    throw error;
  }
};

export const fetchAllTrainersShiftDetails = async (trainerSlot, TOKEN) => {
  try {
    const response = await fetch(
      `${BASE_URL}/trainerShift/getShiftSlots?trainer_id=${trainerSlot}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
        },
      }
    );
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchAllTrainersShiftDetails=> ", error);
    throw error;
  }
};

export const fetchAllSalesReportByFilterType = async (
  pageNo,
  filterType,
  queryParameters,
  searchQuery,
  TOKEN
) => {
  let url = `gym/dashboard/reports/details/v2?page=${pageNo}&limit=10&filter_type=${filterType}${queryParameters}`;
  if (searchQuery) {
    url += `${searchQuery}`;
  }
  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllSalesReportByFilterType=> ", error);
    throw error;
  }
};

export const fetchAllRenewals = async (
  pageNo,
  queryParameters,
  searchQuery,
  TOKEN
) => {
  let url = `gym/dashboard/reports/renewal?is_web=1&page=${pageNo}&limit=10${queryParameters}`;
  if (searchQuery) {
    url += `${searchQuery}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllRenewals=> ", error);
    throw error;
  }
};

export const fetchAllFeedbacks = async (pageNo, queryParameters, TOKEN) => {
  // let url = `feedback/v2?is_web=1&page=${pageNo}&limit=10${queryParameters}`;
  let url = `pt/feedback?page=${pageNo}&limit=10${queryParameters}`;
  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllFeedbacks=> ", error);
    throw error;
  }
};

export const fetchAllPTStats = async (queryParameters, TOKEN) => {
  try {
    const response = await fetch(
      `${BASE_URL}/pt/stats?type=all${queryParameters}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
        },
      }
    );
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllPTStats=> ", error);
    throw error;
  }
};

export const fetchExpiringPTStats = async (queryParameters, TOKEN) => {
  try {
    const response = await fetch(
      `${BASE_URL}/pt/stats?type=expiring${queryParameters}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
        },
      }
    );
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchExpiringPTStats=> ", error);
    throw error;
  }
};

export const fetchPlansPTStats = async (queryParameters, TOKEN) => {
  try {
    const response = await fetch(
      `${BASE_URL}/pt/stats?type=plan_type${queryParameters}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
        },
      }
    );
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchPlansPTStats=> ", error);
    throw error;
  }
};

export const fetchPTCharts = async (queryParameters, TOKEN) => {
  let url = `pt/chart?${queryParameters}`;
  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchPTCharts=> ", error);
    throw error;
  }
};

export const fetchUpcomingPT = async (pageNo, queryParameters, TOKEN) => {
  let url = `pt/upcoming_pt?page=${pageNo ? pageNo : 1}&limit=10${
    queryParameters ? queryParameters : ""
  }`;
  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchUpcomingPT=> ", error);
    throw error;
  }
};

export const fetchAllPTMembers = async (
  pageNo,
  trainerId,
  searchString,
  queryParameters,
  TOKEN
) => {
  let url = `pt/pt_members?page=${pageNo}&limit=10${queryParameters}`;

  if (searchString && trainerId) {
    url += `&trainer_id=${trainerId}&search=${searchString}${queryParameters}`;
  } else if (searchString) {
    url += `&search=${searchString}${queryParameters}`;
  } else if (trainerId) {
    url += `&trainer_id=${trainerId}${queryParameters}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllPTMembers=> ", error);
    throw error;
  }
};

export const fetchAllPTMemberDatewise = async (pageNo, date, qp, TOKEN) => {
  let url = `pt/pt_members?page=${pageNo}&limit=10&date_from=${date}&date_to=${date}${
    qp ? qp : ""
  }`;

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllPTMemberDatewise=> ", error);
    throw error;
  }
};

export const fetchAllPTPlans = async (
  pageNo,
  trainerId,
  searchString,
  queryParameters,
  TOKEN
) => {
  let url = `pt/trainers_pt_plan?page=${pageNo}&limit=10${queryParameters}`;

  if (searchString && trainerId) {
    url = `pt/trainers_pt_plan?page=${pageNo}&limit=10&trainer_id=${trainerId}&search=${searchString}${queryParameters}`;
  } else if (searchString) {
    url = `pt/trainers_pt_plan?page=${pageNo}&limit=10&search=${searchString}${queryParameters}`;
  } else if (trainerId) {
    url = `pt/trainers_pt_plan?page=${pageNo}&limit=10&trainer_id=${trainerId}${queryParameters}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllPTPlans=> ", error);
    throw error;
  }
};

export const fetchTopTrainers = async (
  pageNo,
  searchString,
  queryParameters,
  TOKEN
) => {
  let url = `pt/trainers_pt_stats?page=${pageNo}&limit=100${queryParameters}`;

  if (searchString) {
    url = `pt/trainers_pt_stats?page=${pageNo}&limit=100&search=${searchString}${queryParameters}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchTopTrainers=> ", error);
    throw error;
  }
};

export const fetchTrainersOccupancy = async (queryParameters, TOKEN) => {
  let url = `pt/trainer_occupancy`;

  if (queryParameters) {
    url += `?${queryParameters}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchTrainersOccupancy=> ", error);
    throw error;
  }
};

export const fetchTrainersMonthlyTaget = async (queryParameters, TOKEN) => {
  let url = `staff/target`;

  if (queryParameters) {
    url = `staff/target?${queryParameters}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchTrainersMonthlyTaget=> ", error);
    throw error;
  }
};

export const fetchTrainersTotalMembers = async (queryParameters, TOKEN) => {
  let url = `pt/total_members_stat`;

  if (queryParameters) {
    url = `pt/total_members_stat?${queryParameters}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchTrainersTotalMembers=> ", error);
    throw error;
  }
};

export const fetchLastSales = async (queryParameters, TOKEN, page, limit) => {
  let url = `pt/pt_members?page=${page ? page : 1}&limit=${
    limit ? limit : 5
  }&type=last_5_sale`;

  if (queryParameters) {
    url += `${queryParameters}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchLastSales=> ", error);
    throw error;
  }
};

export const fetchTrainerRatings = async (queryParameters, TOKEN) => {
  let url = `pt/rating`;

  if (queryParameters) {
    url = `pt/rating?${queryParameters}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchTrainerRatings=> ", error);
    throw error;
  }
};

export const fetchAssignedMembers = async (queryParameters, TOKEN) => {
  let url = `pt/assigned_members_detail`;

  if (queryParameters) {
    url = `pt/assigned_members_detail?${queryParameters}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAssignedMembers=> ", error);
    throw error;
  }
};

export const fetchTMTA = async (queryParameters, TOKEN) => {
  let url = `staff/stats`;

  if (queryParameters) {
    url = `staff/stats?${queryParameters}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchTMTA=> ", error);
    throw error;
  }
};

export const fetchMissedPT = async (queryParameters, TOKEN) => {
  let url = `pt/missed_pt`;

  if (queryParameters) {
    url = `pt/missed_pt?${queryParameters}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchMissedPT=> ", error);
    throw error;
  }
};

export const fetchAllTrainers = async (
  pageNo,
  search,
  queryParameters,
  TOKEN
) => {
  try {
    let url = `trainer?page=${pageNo}&limit=10`;

    if (queryParameters && search) {
      url += `${queryParameters}&search=${search}`;
    } else if (queryParameters) {
      url += `${queryParameters}`;
    } else if (search) {
      url += `&search=${search}`;
    }

    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllTrainers=> ", error);
    throw error;
  }
};

export const fetchTSAR = async (queryParameters, TOKEN) => {
  try {
    let url = `staff/trainer_salary_sale_roi_stats`;

    if (queryParameters) {
      url = `staff/trainer_salary_sale_roi_stats?${queryParameters}`;
    }

    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchTSAR=> ", error);
    throw error;
  }
};

export const fetchTargetAchieved = async (queryParameters, TOKEN) => {
  try {
    let url = `staff/target_achieved`;

    if (queryParameters) {
      url = `staff/target_achieved?${queryParameters}`;
    }

    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchTargetAchieved=> ", error);
    throw error;
  }
};

export const fetchGymsAttendance = async (queryParameters, TOKEN) => {
  try {
    let url = `pt/attandance`;

    if (queryParameters) {
      url = `pt/attandance?${queryParameters}`;
    }

    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchGymsAttendance=> ", error);
    throw error;
  }
};

// export const fetchAllSubscription = async (
//   pageNo,
//   queryParameters,
//   TOKEN,
//   pageLimit
// ) =>
export const fetchAllSubscription = async (filters, token) => {
  let url = `subscription?filter_type=all`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `&${filteredParams}`;
  }

  try {
    // let url = `subscription?page=${pageNo}&limit=${
    //   pageLimit ? pageLimit : 10
    // }&filter_type=all`;

    // if (queryParameters) {
    //   url += `${queryParameters}`;
    // }

    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllSubscription=> ", error);
    throw error;
  }
};

export const fetchAllUnmappedUser = async (
  pageNo,
  pageLimit,
  queryParameters,
  TOKEN
) => {
  try {
    let url = `user/unmapped?page=${pageNo}&limit=${pageLimit}`;

    if (queryParameters) {
      url = `user/unmapped?page=${pageNo}&limit=${pageLimit}${queryParameters}`;
    }

    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllUnmappedUser=> ", error);
    throw error;
  }
};

export const fetchPartialPayments = async (
  pageNo,
  queryParameters,
  searchString,
  TOKEN
) => {
  const sendableUrl = searchString
    ? `subscription/partial?page=${pageNo}&limit=10${queryParameters}${searchString}`
    : `subscription/partial?page=${pageNo}&limit=10${queryParameters}`;
  try {
    const response = await fetch(`${BASE_URL}/${sendableUrl}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchPartialPayments=> ", error);
    throw error;
  }
};

export const fetchAllMeals = async (pageNo, limit, queryParameters, TOKEN) => {
  let url = `diet/get-diet/v2?is_web=1&is_new=1&page=${pageNo}&limit=${
    limit ? limit : 10
  }`;

  if (queryParameters) {
    url += `${queryParameters}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllMeals=> ", error);
    throw error;
  }
};

export const fetchIngredients = async (
  pageNo,
  limit,
  queryParameters,
  TOKEN
) => {
  let url = `diet/ingredient?page=${pageNo}&limit=${limit ? limit : 10}`;

  if (queryParameters) {
    url = `diet/ingredient?page=${pageNo}&limit=${
      limit ? limit : 10
    }${queryParameters}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchIngredients=> ", error);
    throw error;
  }
};

export const fetchAllUnits = async (TOKEN, pageNo, limit) => {
  try {
    const response = await fetch(
      `${BASE_URL}/dietunit/get?page=${pageNo}&limit=${limit ? limit : 10}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
        },
      }
    );
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchAllUnits=> ", error);
    throw error;
  }
};

export const fetchAllWatiLogs = async (pageNo, queryParameters, TOKEN) => {
  let url = `wati/lead_log?page=${pageNo}&limit=10`;

  if (queryParameters) {
    url = `wati/lead_log?page=${pageNo}&limit=10${queryParameters}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllWatiLogs=> ", error);
    throw error;
  }
};

export const fetchAllKeywords = async (pageNo, queryParameters, TOKEN) => {
  let url = `wati/predefined_msg?page=${pageNo}&limit=10`;

  if (queryParameters) {
    url = `wati/predefined_msg?page=${pageNo}&limit=10${queryParameters}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllKeywords=> ", error);
    throw error;
  }
};

export const fetchSheetTabsStats = async (queryParameters, TOKEN) => {
  let url = `wati/get_sheet_and_tab`;

  if (queryParameters) {
    url = `wati/get_sheet_and_tab/${queryParameters}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchSheetTabsStats=> ", error);
    throw error;
  }
};

export const exportAllUsersDataByChoice = async (queryParameters, TOKEN) => {
  let url = `user?is_export=1`;

  if (queryParameters) {
    url = `user?is_export=1${queryParameters}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });

    if (!response.ok) {
      console.error("Error status code:", response.status);
      throw new Error(`Request failed with status ${response.status}`);
    }

    const reponseText = await response.text();
    return reponseText;
  } catch (error) {
    console.error("JSON parsing error:", error);
    throw error;
  }
};

export const fetchDietTimings = async (
  pageNo,
  limit,
  queryParameters,
  TOKEN
) => {
  let url = `dietTiming/get?page=${pageNo}&limit=${
    limit ? limit : 10
  }&is_web=1`;

  if (queryParameters) {
    url = `dietTiming/get?page=${pageNo}&limit=${
      limit ? limit : 10
    }&is_web=1${queryParameters}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchDietTimings=> ", error);
    throw error;
  }
};

export const fetchDietTypes = async (pageNo, limit, queryParameters, TOKEN) => {
  let url = `diettype/getall?page=${pageNo}&limit=${
    limit ? limit : 10
  }&type=type1`;

  if (queryParameters) {
    url = `diettype/getall?page=${pageNo}&limit=${
      limit ? limit : 10
    }&type=type1${queryParameters}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchDietTypes=> ", error);
    throw error;
  }
};

export const fetchDietPreference = async (
  pageNo,
  limit,
  queryParameters,
  TOKEN
) => {
  let url = `diettype/getall?page=${pageNo}&limit=${
    limit ? limit : 10
  }&type=type2`;

  if (queryParameters) {
    url = `diettype/getall?page=${pageNo}&limit=${
      limit ? limit : 10
    }&type=type2${queryParameters}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchDietPreference=> ", error);
    throw error;
  }
};

export const fetchDieticians = async (
  pageNo,
  limit,
  queryParameters,
  TOKEN
) => {
  let url = `dietitian?page=${pageNo}&limit=${limit ? limit : 10}`;

  if (queryParameters) {
    url = `dietitian?page=${pageNo}&limit=${
      limit ? limit : 10
    }${queryParameters}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchDieticians=> ", error);
    throw error;
  }
};

export const fetchPtTracks = async (pageNo, limit, queryParameters, TOKEN) => {
  let url = `ptTrial/stats?page=${pageNo}&limit=${limit ? limit : 10}`;

  if (queryParameters) {
    url = `ptTrial/stats?page=${pageNo}&limit=${
      limit ? limit : 10
    }&${queryParameters}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchPtTracks=> ", error);
    throw error;
  }
};

export const fetchPTReports = async (pageNo, limit, queryParameters, TOKEN) => {
  let url = `ptTrial/subs_pt_trial_info?page=${pageNo}&limit=${
    limit ? limit : 10
  }`;

  if (queryParameters) {
    url += `&${queryParameters}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchPTReports=> ", error);
    throw error;
  }
};

export const fetchPTTrialStats = async (queryParameters, TOKEN) => {
  let url = `ptTrial/card_stats`;

  if (queryParameters) {
    url = `ptTrial/card_stats?${queryParameters}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchPTTrialStats=> ", error);
    throw error;
  }
};

export const fetchExpertise = async (pageNo, limit, queryParameters, TOKEN) => {
  let url = `dietitian/expertise?page=${pageNo}&limit=${limit ? limit : 10}`;

  if (queryParameters) {
    url = `dietitian/expertise?page=${pageNo}&limit=${
      limit ? limit : 10
    }${queryParameters}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchExpertise=> ", error);
    throw error;
  }
};

export const fetchDietStats = async (queryParameters, TOKEN) => {
  let url = `diet/dashboard_stats?type=card_stats`;

  if (queryParameters) {
    url += `${queryParameters}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchDietStats=> ", error);
    throw error;
  }
};

export const fetchDietCards = async (pageNo, limit, queryParameters, TOKEN) => {
  let url = `diet/dashboard_stats?page=${pageNo ? pageNo : 1}&limit=${
    limit ? limit : 10
  }`;

  if (queryParameters) {
    url += `${queryParameters}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchDietCards=> ", error);
    throw error;
  }
};

export const fetchAllDietPlan = async (
  pageNo,
  limit,
  queryParameters,
  TOKEN
) => {
  let url = `dietpackage?page=${pageNo ? pageNo : 1}&limit=${
    limit ? limit : 10
  }`;

  if (queryParameters) {
    url += `&${queryParameters}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllDietPlan=> ", error);
    throw error;
  }
};

export const fetchAllDietPackages = async (
  pageNo,
  limit,
  queryParameters,
  TOKEN
) => {
  let url = `dietcat/new?page=${pageNo ? pageNo : 1}&limit=${
    limit ? limit : 10
  }`;

  if (queryParameters) {
    url += `&${queryParameters}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllDietPackages=> ", error);
    throw error;
  }
};

export const fetchMembersById = async (memId, queryParameters, TOKEN) => {
  let url = `member/id/${memId}`;

  if (queryParameters) {
    url += `${queryParameters}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchMembersById=> ", error);
    throw error;
  }
};

export const fetchSubsTypeSales = async (filters, TOKEN) => {
  let url = `gym/stats/subscription-type`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchSubsTypeSales=> ", error);
    throw error;
  }
};

export const fetchBiomaxStats = async (filters, TOKEN) => {
  let url = `subscription/subs_biomax_info?type=card`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `&${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchBiomaxStats=> ", error);
    throw error;
  }
};

export const fetchTotalCheckins = async (filters, TOKEN) => {
  let url = `attandance/stats`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchTotalCheckins=> ", error);
    throw error;
  }
};

export const fetchTrainerReportsStats = async (filters, TOKEN) => {
  let url = `trainer/trainer_report_stats?type=card`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `&${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchTrainerReportsStats=> ", error);
    throw error;
  }
};

export const fetchGTPTreports = async (filters, TOKEN) => {
  let url = `trainer/pt_gt_trainer_stats`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchGTPTreports=> ", error);
    throw error;
  }
};

export const fetchDefaultTrainers = async (filters, TOKEN) => {
  let url = `trainer/trainer_report_stats`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchDefaultTrainers=> ", error);
    throw error;
  }
};

export const fetchTrainerMembers = async (filters, TOKEN) => {
  let url = `trainer/default_trainer_members_checkin_details`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchTrainerMembers=> ", error);
    throw error;
  }
};

export const fetchMemberLogs = async (filters, TOKEN) => {
  let url = `trainer/trainer_report_member_details_on_checkin_date`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchMemberLogs=> ", error);
    throw error;
  }
};

export const fetchCtoCategories = async (filters, TOKEN) => {
  let url = `settelement/v2/cto/category`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchCtoCategories=> ", error);
    throw error;
  }
};

export const fetchCtoHeads = async (filters, TOKEN) => {
  let url = `settelement/v2/cto-heads`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchCtoHeads=> ", error);
    throw error;
  }
};

export const fetchCtoStats = async (filters, TOKEN) => {
  let url = `settelement/v2/cto/stats`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchCtoStats=> ", error);
    throw error;
  }
};

export const fetchDailyTarget = async (filters, TOKEN) => {
  let url = `dailyTargetMatrix`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchDailyTarget=> ", error);
    throw error;
  }
};

export const fetchAllCampaigns = async (filters, TOKEN) => {
  let url = `campaign`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllCampaigns=> ", error);
    throw error;
  }
};

export const fetchAllJobs = async (filters, TOKEN) => {
  let url = `campaign/jobs`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllJobs=> ", error);
    throw error;
  }
};

export const fetchActivePtWithExpiredSub = async (filters, TOKEN) => {
  let url = `pt/regular_pt_subs_stats`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchActivePtWithExpiredSub=> ", error);
    throw error;
  }
};

export const fetchLeaveCategories = async (filters, TOKEN) => {
  let url = `leaveManagement/category`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchLeaveCategories=> ", error);
    throw error;
  }
};

export const fetchApprovalManager = async (filters, TOKEN) => {
  let url = `leaveManagement/approval_manager`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchApprovalManager=> ", error);
    throw error;
  }
};

export const fetchStaffLeaves = async (filters, TOKEN) => {
  let url = `leaveManagement/apply_leave/list`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchStaffLeaves=> ", error);
    throw error;
  }
};

export const fetchStaffLeaveStats = async (filters, TOKEN) => {
  let url = `leaveManagement/cardStats`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchStaffLeaveStats=> ", error);
    throw error;
  }
};

export const fetchGTPTtrainer = async (filters, TOKEN) => {
  let url = `pt/all_pt_trainer_details`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchGTPTtrainer=> ", error);
    throw error;
  }
};

export const fetchAttendanceChart = async (filters, TOKEN) => {
  let url = `attandance/chart`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAttendancePieChart=> ", error);
    throw error;
  }
};

export const fetchAttendance = async (filters, TOKEN) => {
  let url = `attandance`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAttendance=> ", error);
    throw error;
  }
};

export const fetchAssignedNotAssignedMemberReport = async (filters, TOKEN) => {
  let url = `trainer/trainer_report_members_details`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAssignedNotAssignedMemberReport=> ", error);
    throw error;
  }
};

export const fetchLeadStats = async (filters, TOKEN) => {
  let url = `leads/stats/v2`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchLeadStats=> ", error);
    throw error;
  }
};

export const fetchAllLeads = async (filters, TOKEN) => {
  let url = `leads/v2`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllLeads=> ", error);
    throw error;
  }
};

export const fetchLeadValuesConverted = async (filters, TOKEN) => {
  let url = `leads/converted/v2`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchLeadValuesConverted=> ", error);
    throw error;
  }
};

export const fetchRawLeads = async (filters, TOKEN) => {
  let url = `subscription/conversion_without_lead_path`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchRawLeads=> ", error);
    throw error;
  }
};

export const fetchAllGymwisePTStats = async (filters, TOKEN) => {
  let url = `ptTrial/gymwise_stats`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllGymwisePTStats=> ", error);
    throw error;
  }
};

export const fetchAllAgents = async (filters, TOKEN) => {
  let url = `campaign/agents`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllAgents=> ", error);
    throw error;
  }
};

export const fetchPTPartial = async (filters, TOKEN) => {
  let url = `pt/partial_amount_details`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchPTPartial=> ", error);
    throw error;
  }
};

export const fetchURECalendar = async (filters, TOKEN) => {
  let url = `subscription/datewise_expiring_renewals_unpaid`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchURECalendar=> ", error);
    throw error;
  }
};

export const fetchUREDetails = async (filters, TOKEN) => {
  let url = `subscription/datewise_expiring_renewals_unpaid_data`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchUREDetails=> ", error);
    throw error;
  }
};

export const fetchSubsPartialStats = async (filters, TOKEN) => {
  let url = `subscription/partial/stats`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchSubsPartialStats=> ", error);
    throw error;
  }
};

export const fetchSubsPartialPending = async (filters, TOKEN) => {
  let url = `subscription/partial/pending`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchSubsPartialPending=> ", error);
    throw error;
  }
};

export const fetchFollowupStatus = async (filters, TOKEN) => {
  let url = `leads/customer_intent_value`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchFollowupStatus=> ", error);
    throw error;
  }
};

export const fetchCustomerIntent = async (filters, TOKEN) => {
  let url = `leads/customer_intent`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchCustomerIntent=> ", error);
    throw error;
  }
};

export const fetchPTTrainerPerformance = async (filters, TOKEN) => {
  let url = `pt/trainer_pt_performance`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchPTTrainerPerformance=> ", error);
    throw error;
  }
};

export const fetchUnassignedLeads = async (filters, TOKEN) => {
  let url = `leads/unassigned`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchUnassignedLeads=> ", error);
    throw error;
  }
};

export const fetchRawLeadStats = async (filters, TOKEN) => {
  let url = `leads/unassigned/stats`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchRawLeadStats=> ", error);
    throw error;
  }
};

export const fetchRequestedCupons = async (filters, TOKEN) => {
  let url = `payment/coupon_request`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchRequestedCupons=> ", error);
    throw error;
  }
};

export const fetchUREStats = async (filters, TOKEN) => {
  let url = `subscription/calendar_cards`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchUREStats=> ", error);
    throw error;
  }
};

export const fetchCentralisedOffers = async (filters, TOKEN) => {
  let url = `offer/draft/v2`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchCentralisedOffers=> ", error);
    throw error;
  }
};

export const fetchCartPendingPayments = async (filters, TOKEN) => {
  let url = `transaction/incomplete`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchCartPendingPayments=> ", error);
    throw error;
  }
};

export const fetchAllPTSalesStats = async (filters, TOKEN) => {
  let url = `pt/pt_sales_stats`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllPTSalesStats=> ", error);
    throw error;
  }
};

export const fetchTMEStats = async (filters, TOKEN) => {
  let url = `member_engagement/stats`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchTMEStats=> ", error);
    throw error;
  }
};

export const fetchTMEActiveUserStats = async (filters, TOKEN) => {
  let url = `member_engagement/active_user/stats`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchTMEActiveUserStats=> ", error);
    throw error;
  }
};

export const fetchTMEExpiredMembersStats = async (filters, TOKEN) => {
  let url = `member_engagement/expired_user/stats`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchTMEExpiredMembersStats=> ", error);
    throw error;
  }
};

export const fetchTMEExpiredMembers = async (filters, TOKEN) => {
  let url = `member_engagement/expired_user`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchTMEExpiredMembers=> ", error);
    throw error;
  }
};

export const fetchTMEFormSubmission = async (filters, TOKEN) => {
  let url = `member_engagement`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchTMEFormSubmission=> ", error);
    throw error;
  }
};

export const fetchTMEActiveUsers = async (filters, TOKEN) => {
  let url = `member_engagement/active_user?filter_type=mapped_data`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `&${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchTMEActiveUsers=> ", error);
    throw error;
  }
};

export const fetchStaffAttendanceReport = async (filters, TOKEN) => {
  let url = `staff/report/v3`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchStaffAttendanceReport=> ", error);
    throw error;
  }
};

export const fetchLateCheckinsReport = async (filters, TOKEN) => {
  let url = `attandance/late-checkin`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchLateCheckinsReport=> ", error);
    throw error;
  }
};

export const fetchLateCheckinsStats = async (filters, TOKEN) => {
  let url = `attandance/late-checkin-stats`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchLateCheckinsStats=> ", error);
    throw error;
  }
};

export const fetchAgentReportDateWise = async (payload) => {
  const {
    start_date,
    end_date,
    gym_id,
    token,
    user_id,
    page,
    accountType,
    limit,
  } = payload;

  const queryString = new URLSearchParams({
    limit: limit,
    user_id: user_id,
    start_date: start_date || "",
    end_date: end_date || "",
    gym_id: gym_id || "",
    page: page,
    account_type: accountType,
  }).toString();

  const url = `${BASE_URL}/staff/agentwise_datewise_subs_payments/v2?${queryString}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchLeadReportDatewise=> ", error);
    throw error;
  }
};

export const fetchAgentWiseReport = async (payload) => {
  const {
    start_date,
    end_date,
    gym_id,
    token,
    user_id,
    page,
    accountType,
    limit,
  } = payload;

  const queryString = new URLSearchParams({
    limit: limit,
    user_id: user_id || "",
    start_date: start_date || "",
    end_date: end_date || "",
    gym_id: gym_id || "",
    page: page,
    account_type: accountType,
  }).toString();

  const url = `${BASE_URL}/staff/agentwise_subs_payments/v2?${queryString}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAgentWiseReport=> ", error);
    throw error;
  }
};

export const fetchAgentReportTaskSop = async (payload) => {
  const {
    start_date,
    end_date,
    gym_id,
    token,
    user_id,
    page,
    accountType,
    limit,
  } = payload;

  const queryString = new URLSearchParams({
    limit: limit,
    user_id: user_id || "",
    start_date: start_date || "",
    end_date: end_date || "",
    gym_id: gym_id || "",
    page: page,
    account_type: accountType,
  }).toString();

  const url = `${BASE_URL}/staff/gymwise_report?${queryString}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      // Check if the response is okay
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("gymwise_report=> ", error);
    throw error;
  }
};

export const fetchCareer = async (filters, TOKEN) => {
  let url = `${BASE_URL}/career`;
  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchCareerData=> ", error);
    throw error;
  }
};

export const fetchTv = async (filters, TOKEN) => {
  let url = `${BASE_URL}/gym_tv`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchTvData=> ", error);
    throw error;
  }
};

export const fetchTvStakeHolder = async (filters, TOKEN) => {
  let url = `gym_tv/notify_stackholder/`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchTvData=> ", error);
    throw error;
  }
};

export const fetchAgreementReport = async (filters, TOKEN) => {
  let url = `transaction/agreement/all`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchAgreementReport=> ", error);
    throw error;
  }
};

export const fetchClosureReport = async (filters, TOKEN) => {
  let url = `leads/closure_report/stats`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    console.log(responseJson);
    return responseJson;
  } catch (error) {
    console.error("fetchClosureReport=> ", error);
    throw error;
  }
};

export const fetchClosureReportList = async (filters, TOKEN) => {
  let url = `leads/closure_report/list`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    console.log(responseJson);
    return responseJson;
  } catch (error) {
    console.error("fetchClosureReportList=> ", error);
    throw error;
  }
};

export const fetchOneDayMembership = async (filters, TOKEN) => {
  let url = `subscription/one_day_membership`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchOneDayMembership=> ", error);
    throw error;
  }
};

export const fetchAbandonedCart = async (filters, TOKEN) => {
  let url = `subscription/one_day_membership_lead`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchAbandonedCart=> ", error);
    throw error;
  }
};

export const fetchODMAll = async (filters, TOKEN) => {
  let url = `subscription/one_day_membership_lead/all`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchODMAll=> ", error);
    throw error;
  }
};

export const fetchGymwiseODM = async (filters, TOKEN) => {
  let url = `subscription/one_day_membership_lead/stats/gymwise`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchGymwiseODM=> ", error);
    throw error;
  }
};
export const fetchTimeSheet = async (filters, TOKEN) => {
  let url = `timesheetManagement`;
  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");
  if (filteredParams) {
    url += `?${filteredParams}`;
  }
  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchTimeSheet=> ", error);
    throw error;
  }
};

export const fetchSheetContent = async (uid, TOKEN) => {
  let url = `timesheetManagement/slot_details?sheet_id=${uid}`;
  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchSheetContent=> ", error);
    throw error;
  }
};

export const fetchVersionListing = async (filters, TOKEN) => {
  let url = `version`;
  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");
  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchVersionData=> ", error);
    throw error;
  }
};

export const fetchGallery = async (TOKEN, filters) => {
  let url = `gallery`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");
  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchVersionData=> ", error);
    throw error;
  }
};

export const fetchCentralizedBenefits = async (TOKEN, filters) => {
  let url = `benefits/v2`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");
  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchCentralizedBenefits=> ", error);
    throw error;
  }
};

export const fetchNotification = async (TOKEN, filters) => {
  let url = `notification`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchNotification => ", error);
    throw error;
  }
};

export const fetchTodayPTRevenueDetail = async (filters, TOKEN) => {
  let url = `pt/today_pt_sales/data`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchTodayPTRevenueDetail => ", error);
    throw error;
  }
};

export const fetchTickets = async (filters, TOKEN) => {
  try {
    let url = ticketSystem;
    const filteredParams = Object.entries(filters)
      .filter(([_, value]) => value !== "")
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join("&");
    if (filteredParams) {
      url += `?${filteredParams}`;
    }

    const response = await fetch(`${BASE_URL}${url}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchTickets=> ", error);
    throw error;
  }
};

export const fetchTicketStats = async (stats_type, TOKEN, filters = {}) => {
  try {
    const queryParams = new URLSearchParams({
      stats_type,
      ...filters,
    });

    const response = await fetch(
      `${BASE_URL}${ticketSystemStats}?${queryParams.toString()}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${TOKEN}`,
        },
      }
    );
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchTicketStats=> ", error);
    throw error;
  }
};

export const fetchTicketTat = async (ticket_id, TOKEN) => {
  try {
    const response = await fetch(
      `${BASE_URL}${ticketSystemTat}?ticket_id=${ticket_id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${TOKEN}`,
        },
      }
    );
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchTicketTat=> ", error);
    throw error;
  }
};

export const fetchUntrackedWatiLeads = async (filters, TOKEN) => {
  let url = `wati/untracked`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchUntrackedWatiLeads=> ", error);
    throw error;
  }
};

// export const fetchLeadsOwner = async (filters, TOKEN) => {
//   let url = `leads/lead-owner`;

//   const filteredParams = Object.entries(filters)
//     .filter(([_, value]) => value !== "")
//     .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
//     .join("&");

//   if (filteredParams) {
//     url += `?${filteredParams}`;
//   }

//   try {
//     const response = await fetch(`${BASE_URL}/${url}`, {
//       method: "GET",
//       headers: {
//         Authorization: `Bearer ${TOKEN}`,
//       },
//     });
//     const responseJson = await response.json();
//     return responseJson;
//   } catch (error) {
//     console.error("fetchLeadsOwner=> ", error);
//     throw error;
//   }
// };


/* ===== Unified PT View (ported from main) — read-only reporting APIs ===== */

// Unified PT View — paginated trainer-wise stats table
export const fetchTrainerWiseStats = async (params, TOKEN) => {
  const query = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== "")
    .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
    .join("&");
  const url = query
    ? `ptTrial/trainer-wise-stats?${query}`
    : `ptTrial/trainer-wise-stats`;
  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: { Authorization: `Bearer ${TOKEN}` },
    });
    return await response.json();
  } catch (error) {
    console.error("fetchTrainerWiseStats=> ", error);
    throw error;
  }
};

// Unified PT View — drill-down: members for a specific trainer + type
export const fetchPtTrainerMembers = async (params, TOKEN) => {
  const query = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== "")
    .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
    .join("&");
  const url = query
    ? `ptTrial/trainer-members?${query}`
    : `ptTrial/trainer-members`;
  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: { Authorization: `Bearer ${TOKEN}` },
    });
    return await response.json();
  } catch (error) {
    console.error("fetchPtTrainerMembers=> ", error);
    throw error;
  }
};

// Unified PT View — global KPI totals for summary cards
export const fetchTrainerWiseTotals = async (params, TOKEN) => {
  const query = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== "")
    .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
    .join("&");
  const url = query
    ? `ptTrial/trainer-wise-totals?${query}`
    : `ptTrial/trainer-wise-totals`;
  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: { Authorization: `Bearer ${TOKEN}` },
    });
    return await response.json();
  } catch (error) {
    console.error("fetchTrainerWiseTotals=> ", error);
    throw error;
  }
};

// Lead Analytics — gym-wise lead performance (ported from main /leads/analytics/gymwise)
// Read-only. Distinct name to avoid colliding with powered's fetchWaitGymwise (WATI stats).
export const fetchLeadAnalyticsGymwise = async (params, TOKEN) => {
  const query = Object.entries(params || {})
    .filter(([, v]) => v !== undefined && v !== null && v !== "")
    .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
    .join("&");
  const url = query
    ? `leads/analytics/gymwise?${query}`
    : `leads/analytics/gymwise`;
  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: { Authorization: `Bearer ${TOKEN}` },
    });
    return await response.json();
  } catch (error) {
    console.error("fetchLeadAnalyticsGymwise=> ", error);
    throw error;
  }
};

// Unified PT View — all active trainers for filter dropdown
export const fetchTrainerListDropdown = async (gymId, TOKEN) => {
  const url = gymId
    ? `ptTrial/trainer-list?gym_id=${encodeURIComponent(gymId)}`
    : `ptTrial/trainer-list`;
  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: { Authorization: `Bearer ${TOKEN}` },
    });
    return await response.json();
  } catch (error) {
    console.error("fetchTrainerListDropdown=> ", error);
    throw error;
  }
};


// ===== Followup Analytics (ported from main) — read-only APIs =====
export const fetchLeadSources = async (TOKEN) => {
  try {
    const response = await fetch(
      `${BASE_URL}/leads/followup-analytics/sources`,
      {
        method: "GET",
        headers: { Authorization: `Bearer ${TOKEN}` },
      },
    );
    return await response.json();
  } catch (error) {
    console.error("fetchLeadSources=> ", error);
    throw error;
  }
};

export const downloadFollowupAnalyticsCsv = async (params, TOKEN) => {
  const qs = Object.entries({ ...(params || {}), export: "csv" })
    .filter(([key, value]) => value !== "" && value != null)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");
  const url = `${BASE_URL}/leads/followup-analytics${qs ? `?${qs}` : ""}`;
  const res = await fetch(url, {
    headers: { Authorization: `Bearer ${TOKEN}` },
  });
  if (!res.ok) {
    throw new Error(`Export failed (HTTP ${res.status})`);
  }
  return await res.blob();
};

export const postScoreRemark = async (logId, TOKEN) => {
  try {
    const response = await fetch(
      `${BASE_URL}/leads/followup-analytics/score-remark`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ log_id: logId }),
      },
    );
    return await response.json();
  } catch (error) {
    console.error("postScoreRemark=> ", error);
    throw error;
  }
};

export const fetchFollowupAnalytics = async (params, TOKEN) => {
  let url = `leads/followup-analytics`;

  const filteredParams = Object.entries(params || {})
    .filter(([key, value]) => value !== "" && value != null)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchFollowupAnalytics=> ", error);
    throw error;
  }
};

// ===== TV Monitoring Dashboard (ported from main) =====
export const fetchTvMonitoringDashboard = async (filters, TOKEN) => {
  let url = `${BASE_URL}/tv_monitoring/dashboard`;

  const filteredParams = Object.entries(filters || {})
    .filter(([key, value]) => value !== "" && value !== null && value !== undefined)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: { Authorization: `Bearer ${TOKEN}` },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchTvMonitoringDashboard=> ", error);
    throw error;
  }
};

export const fetchTvMonitoringGymStats = async (TOKEN) => {
  try {
    const response = await fetch(`${BASE_URL}/tv_monitoring/gym_stats`, {
      method: "GET",
      headers: { Authorization: `Bearer ${TOKEN}` },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchTvMonitoringGymStats=> ", error);
    throw error;
  }
};
